import { Section } from "types/Models/Filing";

// only the books handoff step groups its fields into sub sections
export const hasSubSections = (
  section?: Pick<Section, "sub_sections"> | null
): boolean => (section?.sub_sections?.length ?? 0) > 0;
